// context/ReviewContext.jsx
"use client";
import React, { createContext, useContext, useState, useEffect } from 'react';
import { BASE_URL } from '../config/config';

const ReviewContext = createContext();

export const ReviewProvider = ({ productId, children }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId) return;

    const fetchReviews = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/rating/${productId}`);
        if (!res.ok) throw new Error("Failed to fetch reviews");
        
        const result = await res.json();

        // Normalize to array
        const dataArray = Array.isArray(result.data) ? result.data : [result.data];

        const mapped = dataArray.map((r) => ({
          id: r.id,
          rating: parseInt(r.stars),
          title: r.review,
          date: r.create_audit_time,
          author: r.user_name,
          avatar: `${BASE_URL}/users/${r.image}`,
          likes: Math.floor(Math.random() * 100), // mock likes
          hasMedia: !!r.image,
          hasDescription: !!r.review
        }));

        setReviews(mapped);
      } catch (err) {
        console.error(err);
        setError("Error loading reviews.");
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [productId]);

  return (
    <ReviewContext.Provider value={{ reviews, loading, error }}>
      {children}
    </ReviewContext.Provider>
  );
};

export const useReviews = () => useContext(ReviewContext);
